import GetDriverInfo from "../symbols/getDriverInfo";

interface IState {
  data: string;
  loading: boolean;
  error: boolean;
}
const initialState: IState = {
  data: '',
  loading: false,
  error: false,
};

export default function GetDriverInfoReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case GetDriverInfo.GET_DRIVER_INFO:
      return { ...state, loading: true, error: false };
    case GetDriverInfo.GET_DRIVER_INFO_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case GetDriverInfo.GET_DRIVER_INFO_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case GetDriverInfo.CLEAR_GET_DRIVER_INFO:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
